module.exports = __webpack_public_path__ + "img/hu.f7a83d55.svg";